export default __webpack_public_path__ + "static/media/autobild.e5f375d8.png";